export const initPhoneAssignmentConfig = function(ignoreCTParamToShowNumber = false) {
	const params = window.modUtils.getUrlParamsToObject();
	const ctParam = params.CT && params.CT.toLowerCase();
	if (ctParam === 'yes' || ignoreCTParamToShowNumber) {
		window.modForm.opts.phoneAssignmentConfig.showPhoneAssignmentNumber = true;
	}
	window.modForm.opts.phoneAssignmentConfig.useHsEndpoint = true;
};